module.exports = __webpack_public_path__ + "static/media/news-small.bc2ba39f.webp";